var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-switch',{attrs:{"value":_vm.$vuetify.theme.dark},on:{"input":_vm.updateTheme}},[_vm._v(" 🌛 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }